import {busy, fieldValue} from "../common/NamaCommon";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {translateId} from "../common/Translator";
import {findFieldMetadata} from "../common/Metadata";
import {getTrimmedId, modelId} from "./NamaGridWidget";
import {EditScreenGroup} from "../views/edit/EditScreenGroup";
import {attachNextAndPreviousFocus} from "../routing/EditPresenter";
import {currentRowAbsoluteNumber} from "../views/list/ListViewColumns";
import {applyWidgetState} from "../common/GUIUtilities";
import {SEPARATOR} from "../constants/CommonConstants";

export function gridKey(grid) {
    if (grid.owner && grid.owner.entityType)
        return grid.owner.entityType + SEPARATOR + grid.id + SEPARATOR + "useDetailedGrids";
    return grid.id + SEPARATOR + "useDetailedGrids";
}

export class NamaGridLineEditor {
    constructor(grid, dataItem) {
        let that = this;
        that.grid = grid;
        that.popupWidgets = [];
        that.widgetsWithTrimmedId = new Map();
        grid.popupEditor = that;
        let kendoGrid = that.grid._kendoGrid();
        that.columns = kendoGrid.columns.flatMap(c => c.columns ? c.columns : c).filter(c => c.id && (!c.editable || (c.editable && c.editable() === true)));
        that.group = new EditScreenGroup();
        that.groupContainer = that.group.drawGroup({});
        let paneWrapper = that.grid.findElement().closest(".k-pane-wrapper");
        paneWrapper && paneWrapper.length ? paneWrapper.after(that.groupContainer) : that.grid.findElement().after(that.groupContainer);
        let detailMetadata = findFieldMetadata(that.grid.id, that.grid.metaData);
        for (let col of that.columns) {
            let columnMetadata = findFieldMetadata(col.id, that.grid.metaData);
            if (!columnMetadata)
                continue;
            let trimmedId = getTrimmedId(columnMetadata, detailMetadata);
            that.widgetsWithTrimmedId.set(columnMetadata.fieldId, trimmedId);
            if (col.editor)
                col.editor(that, {field: modelId(col.id), model: dataItem});
        }
        for (let w of that.popupWidgets) {
            w.afterAttach();
        }
        attachNextAndPreviousFocus(that.groupContainer);
        let gridShortCuts = that.findGridShortCuts();
        that.removeEditorBtn = $(`<button class="k-button" id = "removeEditor" title="${translateId("removeEditor")}">
                <span class="k-icon k-i-close gridToolBarIcon" ></span></button>`);
        that.editLineBtn = $(`<button class="k-button" id = "editLine" title="${translateId("editLine")}">
                <span class="k-icon k-i-edit gridToolBarIcon" ></span></button>`);
        gridShortCuts.append(that.removeEditorBtn);
        gridShortCuts.find("#editLine").remove();
        that.removeEditorBtn.on("click", (e) => that.removeEditorPart());
    }

    findGridShortCuts() {
        return this.grid.findElement().find("#shortCutBtns");
    }

    findColById(id) {
        let gridColumns = this.columns.filter(c => c.id === id);
        return gridColumns && gridColumns.length ? gridColumns[0] : null;
    }

    addWidget(widget) {
        this.popupWidgets.push(widget);
    }

    updatePopupEditWidgetsState(state) {
        let that = this;
        let filtered = that.popupWidgets.filter(w => w.id === state.fieldId);
        let widget = filtered ? filtered[0] : undefined;
        if (widget)
            applyWidgetState(widget, state.state);

    }

    updatePopupEditWidgetsValues(rowIndex) {
        let that = this;
        if (busy()) {
            setTimeout(() => that.updatePopupEditWidgetsValues(rowIndex), 97);
            return;
        }
        for (let w of that.popupWidgets) {
            w.setValue(that.grid.owner.getFieldValue(w.id, rowIndex));

        }
    }

    removeEditorPart() {
        let that = this;
        localStorage.setItem(gridKey(that.grid), "false");
        let gridShortCuts = that.findGridShortCuts();
        that.groupContainer.remove();
        that.grid.popupEditor = undefined;
        that.removeEditorBtn.remove();
        gridShortCuts.append(that.editLineBtn);
    }

    show(dataItem, rowIndex) {
        let that = this;
        that.rowIndex = rowIndex;
        that.lineId = dataItem.id;
        that.currentDataItem = dataItem;
        that.groupContainer.find(".gridLineEditorHeader").text(that.grid.calcGridTitle() + "   #" + currentRowAbsoluteNumber(that.grid._kendoGrid()));
        for (let w of that.popupWidgets) {
            w.cellOptions = {field: modelId(w.id), model: dataItem};
            w.setValue(fieldValue(dataItem, that.widgetsWithTrimmedId.get(w.id)));
            if (that.grid.fetchCell(rowIndex, w.id).attr("readonly"))
                w.setEnabled(false);
        }
    }

    rootElement() {
        return this.groupContainer.find(".widgetsList");
    }

    editorWindowShow() {
        let that = this;
        that.window = new NamaKendoWindow(translateId(grid.id), new NamaWindowBtnData("ok", () => {
            that.editorWindowClose();
        }), new NamaWindowBtnData("cancel", () => {
            that.editorWindowClose();
        }));
        that.window.width = "80%";
        that.window.height = "50%";
        that.window.content.append(that.groupContainer);
        that.window.showWindow();
    }

    editorWindowClose() {
        let that = this;
        that.window.closeWindow();
        that.grid.popupEditor = undefined;
    }
}